
export default {
  data() {
    return {
      showPassword: false,
      showConfirmedPassword: false,
    };
  },
};
